import { createReducer, SerializedError } from "@reduxjs/toolkit"
import {
  getPupilSocialEmotionalNotes,
  addPupilSocialEmotionalNote,
  updatePupilSocialEmotionalNote,
  deletePupilSocialEmotionalNote,
} from "./social-emotional.actions"

export interface PupilSocialEmotionalNote {
  id: number
  pupilId: number
  yearclassId: number
  categoryId: number
  categoryName: string
  content: string
  position: number
  yearclassAcademicYear: number
  yearclassCalendarYear: number
  userCreatedId: number
  userCreatedName: string
  dateCreated: string
  userChangedId: number | null
  userName: string | null
  dateChanged: string | null
  userArchivedId: number | null
  userArchivedName: string | null
  dateArchived: string | null
}

interface State {
  notes: PupilSocialEmotionalNote[]
  error: SerializedError | null
}

const initialState: State = {
  notes: [],
  error: null,
}

export default createReducer(initialState, (builder) => {
  builder.addCase(getPupilSocialEmotionalNotes.pending, (state) => state)
  builder.addCase(getPupilSocialEmotionalNotes.fulfilled, (state, action) => {
    state.notes = action.payload
  })
  builder.addCase(getPupilSocialEmotionalNotes.rejected, (state, action) => {
    state.error = action.error
  })
  builder.addCase(addPupilSocialEmotionalNote, (state, action) => {
    const note = action.payload
    state.notes.push(note)
  })
  builder.addCase(updatePupilSocialEmotionalNote, (state, action) => {
    const note = action.payload
    state.notes = state.notes.map((n) => (n.id === note.id ? note : n))
  })
  builder.addCase(deletePupilSocialEmotionalNote, (state, action) => {
    const noteId = action.payload
    state.notes = state.notes.filter((n) => n.id !== noteId)
  })
})
